export default __webpack_public_path__ + "financial7bf5e6.jpg";